import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./styles.less";

const Button = ({
  className,
  onClick,
  title,
  isDealStyle,
  isSubmit,
  children
}) => {
  return (
    <button
      type={isSubmit ? "submit" : "button"}
      className={cx(styles.button, className, { [styles.deal]: isDealStyle })}
      onClick={onClick}
      onKeyDown={onClick}
      tabIndex="0"
    >
      {title ? title : children}
    </button>
  );
};

Button.defaultProps = {
  className: "",
  onClick: () => {},
  title: "",
  isDealStyle: false,
  isSubmit: false
};

Button.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string,
  isDealStyle: PropTypes.bool,
  isSubmit: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/common/Button/Button.js